{
  "navigation": {
    "general": "Général",
    "dashboard": "Tableau de bord",
    "home": "Centre d'Apprentissage",
    "patients": "Patients",
    "profile": "Profil",
    "subscription": "Abonnement",
    "roles": {
      "institution": "Institution",
      "practitioner": "Praticien"
    },
    "emailVerification": {
      "title": "Vérifiez votre Email",
      "description": "Vérifiez votre email et cliquez sur le lien pour finaliser votre compte.",
      "resendButton": "Renvoyer",
      "resendSuccess": "Email de vérification envoyé ! Veuillez vérifier votre boîte de réception."
    },
    "logoAlt": "Logo MetaDevProfile",
    "brandName": "MetaDevProfile"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "description": "Bienvenue sur votre tableau de bord praticien",
    "defaultName": "Docteur",
    "greeting": {
      "morning": "Bonjour",
      "afternoon": "Bonne après-midi",
      "evening": "Bonsoir"
    },
    "stats": {
      "totalPatients": "Total Patients",
      "patientsDescription": "Patients sous vos soins",
      "articles": "Articles",
      "articlesDescription": "Articles disponibles",
      "videos": "Vidéos",
      "videosDescription": "Vidéos éducatives",
      "trainings": "Formations",
      "trainingsDescription": "Matériel de formation"
    },
    "recentPatients": {
      "title": "Patients Récents",
      "description": "Vos patients récemment ajoutés",
      "viewAll": "Voir tous les patients",
      "noPatients": "Aucun patient pour le moment",
      "createFirst": "Créer votre premier patient"
    },
    "recentContent": {
      "title": "Contenu Récent",
      "description": "Derniers articles, vidéos et formations",
      "articles": "Articles",
      "videos": "Vidéos",
      "trainings": "Formations",
      "noContent": "Aucun contenu disponible"
    }
  },
  "home": {
    "title": "Centre d'Apprentissage",
    "description": "Accédez aux articles, vidéos et formations pour améliorer vos connaissances",
    "totalContent": "ressources disponibles",
    "tabs": {
      "articles": "Articles",
      "videos": "Vidéos",
      "trainings": "Formations"
    },
    "search": {
      "placeholder": "Rechercher du contenu...",
      "noResults": "Aucun contenu trouvé",
      "tryDifferentTerms": "Essayez d'utiliser des termes de recherche différents ou parcourez tout le contenu"
    },
    "articles": {
      "empty": "Aucun article disponible",
      "emptyDescription": "Revenez plus tard pour de nouveaux articles et ressources",
      "read": "Lire l'Article"
    },
    "videos": {
      "empty": "Aucune vidéo disponible",
      "emptyDescription": "Revenez plus tard pour du nouveau contenu vidéo",
      "watch": "Regarder la Vidéo"
    },
    "trainings": {
      "empty": "Aucune formation disponible",
      "emptyDescription": "Revenez plus tard pour de nouveaux programmes de formation",
      "start": "Commencer la Formation"
    }
  },
  "mobileRedirect": {
    "title": "Application Mobile Non Supportée",
    "description": "La version web n'est pas encore supportée sur les appareils mobiles. Nous recommandons de télécharger notre application mobile pour une meilleure expérience.",
    "downloadTitle": "Téléchargez Notre Application Mobile",
    "downloadButton": "Télécharger l'App",
    "instructions": {
      "title": "Comment commencer :",
      "step1": "Cliquez sur le bouton de téléchargement pour aller sur le store de votre appareil",
      "step2": "Installez l'application MetaDevProfile depuis le store",
      "step3": "Connectez-vous avec les mêmes identifiants que vous utilisez pour cette interface web"
    }
  },
  "errors": {
    "loadPractitionersFailed": "Échec du chargement des praticiens",
    "loadDetailsFailed": "Échec du chargement des détails du praticien"
  }
}
